import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatButtonModule } from '@angular/material/button';

import { HeroModule } from 'src/app/shared/components/hero/hero.module';
import { InvoiceModule } from '../../../shared/components/invoice/invoice.module';
import { PackageModule } from '../../../shared/components/package/package.module';
import { ProductModule } from "../../../shared/components/product/product.module";
import { ProductChoiceModule } from "../../../shared/components/product-choice/product-choice.module";

import {PaymentFormModule} from "../../../shared/components/payment-form/payment-form.module";
import {SelfAttendanceAutoRechargePaymentComponent} from "./auto-recharge-payment.component";

import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';

@NgModule({
    imports: [
        CommonModule,
        
        MatButtonModule,
        HeroModule,
        InvoiceModule,
        PackageModule,
        ProductModule,
        ProductChoiceModule,
        PaymentFormModule,
        MatCardModule,
        MatIconModule
    ],
  exports: [
    SelfAttendanceAutoRechargePaymentComponent
  ],
  providers: [
  ],
  declarations: [
    SelfAttendanceAutoRechargePaymentComponent
  ]
})

export class SelfAttendanceAutoRechargePaymentModule { }
